import { Modal } from "antd";
import SelectTipoConsumo from "components/Input/SelectTipoConsumo";
import { TipoConsumoEnum } from "core/features/consumo/typings";
import { useState } from "react";
import FooterModal from "ui/components/Button/FooterModal";
import SelectMonthYear from "ui/components/Input/SelectMonthYear";
import moment from "moment";
import { Box } from "@chakra-ui/react";
import { FormLabel } from "@chakra-ui/form-control";
interface ModalEscolherTipoProps {
  open: boolean;
  onSave: (tipo: TipoConsumoEnum, mes: string) => any;
  onClose: () => any;
}

export default function ModalEscolherTipo({
  open,
  onSave,
  onClose,
}: ModalEscolherTipoProps) {
  const [tipo, setTipo] = useState<TipoConsumoEnum | undefined>();
  const [mes, setMes] = useState<string | undefined>(
    moment().format("YYYY-MM")
  );

  return (
    <Modal
      visible={open}
      width="400px"
      title={"Escolher tipo de consumo e mês"}
      footer={
        <FooterModal
          showRegisterAnother={false}
          onSubmit={() => onSave(tipo!, mes!)}
          isDisabled={!tipo}
          onClose={onClose}
          buttonCancelarText="Fechar"
          primaryButtonText="Concluir"
        />
      }
    >
      <Box mb={2} mt={-6}>
        <FormLabel
          color="gray.600"
          fontWeight="400"
          fontSize="13px"
          noOfLines={1}
          mb="0"
        >
          Tipo de consumo
        </FormLabel>
        <SelectTipoConsumo
          value={tipo}
          onChange={setTipo}
          className="antd-select-white-bg antd-select-force-white-bg ant-select-customize-input"
        />
      </Box>

      <FormLabel
        color="gray.600"
        fontWeight="400"
        fontSize="13px"
        noOfLines={1}
        mb="0"
      >
        Mês
      </FormLabel>
      <SelectMonthYear
        bg="white"
        value={moment(mes, "YYYY-MM")}
        onChange={(date) => setMes(date?.format("YYYY-MM"))}
        placeholder="Selecione um mês"
        style={{ width: "100%" }}
      />
    </Modal>
  );
}
